__turbopack_context__.v({
  "arrows": "pJ3RQW_arrows",
  "badges": "pJ3RQW_badges",
  "body": "pJ3RQW_body",
  "card": "pJ3RQW_card",
  "category": "pJ3RQW_category",
  "description": "pJ3RQW_description",
  "discount": "pJ3RQW_discount",
  "fact": "pJ3RQW_fact",
  "facts": "pJ3RQW_facts",
  "foot": "pJ3RQW_foot",
  "frame": "pJ3RQW_frame",
  "from": "pJ3RQW_from",
  "go": "pJ3RQW_go",
  "headRow": "pJ3RQW_headRow",
  "heading": "pJ3RQW_heading",
  "image": "pJ3RQW_image",
  "location": "pJ3RQW_location",
  "media": "pJ3RQW_media",
  "meta": "pJ3RQW_meta",
  "name": "pJ3RQW_name",
  "nav": "pJ3RQW_nav",
  "perPerson": "pJ3RQW_perPerson",
  "pill": "pJ3RQW_pill",
  "pillText": "pJ3RQW_pillText",
  "price": "pJ3RQW_price",
  "priceBlock": "pJ3RQW_priceBlock",
  "rail": "pJ3RQW_rail",
  "railButton": "pJ3RQW_railButton",
  "section": "pJ3RQW_section",
  "title": "pJ3RQW_title",
  "truncate": "pJ3RQW_truncate",
  "viewAll": "pJ3RQW_viewAll",
  "was": "pJ3RQW_was",
});
